import { ModelRenderer } from '../ModelRenderer';

export abstract class BaseMRService {
  constructor(protected mr: ModelRenderer) {
  }
  // Initialization code if needed
  public load(): Promise<void> {
    return Promise.resolve();
  }
  public render(delta: number): void {}
  public dispose(): void { }
  public getService<T extends BaseMRService>(type: new (wr: ModelRenderer) => T): T {
    const part = this.mr.services.find((f) => f instanceof type) as T;
    if (!part) {
      throw new Error(`Part not found: ${type.name}`);
    }
    return part;
  }
}